export class WebBloqueioFuncEntidade {
  public OID_BLOQUEIO_FUNC: number;
  public OID_FUNCIONALIDADE: number;
  public CD_FUNDACAO: string;
  public CD_EMPRESA: string;
  public CD_PLANO: string;
  public NUM_MATRICULA: string;
  public DTA_INICIO?: Date;
  public DTA_FIM?: Date;
  public DTA_CRIACAO: Date;
  public TXT_MOTIVO_BLOQUEIO: string;
  public NOM_USUARIO: string;
  public DES_FUNCIONALIDADE: string;
  public SIGLA_ENTID: string;
  public DS_PLANO: string;
}